import { RouteObject } from 'react-router-dom';

import { BubbleError, SettingsLayout } from '@/components';
import { settingRoutes } from '@/features/settings/routes';

export const mainSettingsRoute: RouteObject = {
  element: <SettingsLayout />,
  children: [settingRoutes],
  errorElement: <BubbleError />,
};
